import { Link } from "react-router-dom";
import MaskWeb from "../../assets/png/maskweb.webp";
import MaskMobile from "../../assets/png/maskmobile.webp";
import ScrollAnimation from "./animations/ScrollAnimation";

const CardFooter = () => {
  return (
    <section className="py-10 bg-background md:py-20">
      <div className="max-w-[1500px] mx-auto">
        {/* Section pour les écrans larges */}
        <ScrollAnimation direction="bottom" delay={1}>
          <div className="hidden sm:block">
            <div
              className="h-[511px] rounded-[30px] mx-16 lg:mx-28"
              style={{
                backgroundImage: `url(${MaskWeb})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            >
              <h1 className="text-center text-6xl pb-10 pt-52 xl:text-[70px]">
                Une idée à concrétiser ?
              </h1>
              <Link
                to="/contactez-nous"
                className="flex justify-center lg:max-w-[470px] mx-auto"
              >
                <button className=" text-center text-2xl lg:mx-auto bg-white text-bluecoming py-5 px-7  font-semibold rounded-[64px]">
                  Discutons-en dès maintenant 👋
                </button>
              </Link>
            </div>
          </div>
        </ScrollAnimation>

        {/* Section pour les écrans mobiles */}
        <div className="block sm:hidden">
          <div
            className="h-[450px] rounded-[40px] mx-2"
            style={{
              backgroundImage: `url(${MaskMobile})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          >
            <h1 className="text-5xl text-center pt-28 pb-10">
              Une idée à concrétiser ?
            </h1>
            <Link to="/contactez-nous" className="flex justify-center">
              <button className=" text-center text-2xl bg-white text-bluecoming py-5 px-9 lg:max-w-[470px] mx-auto font-semibold rounded-[64px]">
                Discutons-en 👋
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CardFooter;
